
















































import Vue, { PropType } from 'vue'
import { ValuationPreview } from '@/interfaces/valuation/ValuationRecord'

export default Vue.extend({
  props: {
    preview: Object as PropType<ValuationPreview>,
  },
  methods: {
    copyToClipboard(value: string): void {
      const el = document.createElement('textarea')
      el.value = value
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      const message = this.$createMessage('Hodnota zkopírována')
      this.$store.dispatch(
        'app/addTempMessage',
        { message, timeout: 1500 },
        { root: true }
      )
    },
  },
})
